import {LANG_HYPHEN_REG_BY_LOCALE, Language, Locale} from '../../enums/language';

export interface LanguageInfo {
    key: Language;
    label: string;
    shortLabel: string;
    flagKey: string;
    value: Locale;
    l10nSchemaLang: string;
}

export const DISPLAY_LANGUAGE_LIST: LanguageInfo[] = [
    {
        key:            Language.EN,
        label:          'enums.languages.english',
        shortLabel:     'enums.languages.english_short',
        flagKey:        'us',
        value:          Locale.en_US,
        l10nSchemaLang: LANG_HYPHEN_REG_BY_LOCALE[Locale.en_US]
    },
    {
        key:            Language.RU,
        label:          'enums.languages.russian',
        shortLabel:     'enums.languages.russian_short',
        flagKey:        'ru',
        value:          Locale.ru_RU,
        l10nSchemaLang: LANG_HYPHEN_REG_BY_LOCALE[Locale.ru_RU]
    },
    {
        key:            Language.ES,
        label:          'enums.languages.spanish',
        shortLabel:     'enums.languages.spanish_short',
        flagKey:        'es',
        value:          Locale.es_ES,
        l10nSchemaLang: LANG_HYPHEN_REG_BY_LOCALE[Locale.es_ES]
    }
];
